module.exports = __webpack_public_path__ + "vue_assets/img/img_membership_sub_6m.36b543a8.png";